import React, { useMemo, useRef, useEffect, useState } from "react";

interface DialogMenuProps {
  trigger: React.ReactNode;
  children: React.ReactNode;
  title?: string;
  className?: string;
  contentClassName?: string;
  overlayClassName?: string;
  open?: boolean;
  onOpenChange: (open: boolean) => void;
  maxHeight?: string;
}

export const DialogMenu: React.FC<DialogMenuProps> = ({
  trigger,
  children,
  title,
  className,
  contentClassName,
  overlayClassName,
  open,
  onOpenChange,
  maxHeight = "480px",
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (contentRef.current) {
      const { scrollHeight, clientHeight } = contentRef.current;
      setIsOverflowing(scrollHeight > clientHeight);
    }
  }, [children, maxHeight]);

  const tr = useMemo(() => {
    return React.cloneElement(trigger as React.ReactElement, {
      onClick: () => onOpenChange?.(true)
    });
  }, [trigger, onOpenChange, open]);

  if (!open) return tr;
  return (
    <>
      {tr}
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <div 
          className={`fixed inset-0 bg-black bg-opacity-50 ${overlayClassName || ''}`}
          onClick={() => onOpenChange?.(false)}
        />
        <div className={`relative bg-white rounded-lg shadow-lg border-2 border-gray-300 ${contentClassName || ''}`}>
          <div className="flex flex-col md:max-w-md mx-auto">
              <div className="flex items-center justify-between pb-2">
                <div className="flex-1 text-lg font-semibold text-gray-900">{title}</div>
                  <button className="font-bold text-gray-500 hover:text-gray-700"
                    onClick={() => onOpenChange(false)}
                    aria-label="Close"
                  >X</button>
              </div>
            <div className="flex flex-col items-center gap-0 md:gap-2 mt-0 md:mt-2 mb-4">

              {/* Content area */}
              <div
                ref={contentRef}
                className={`flex justify-center overflow-y-auto ${className || ''}`}
                style={{ maxHeight }}
              >
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}; 